module.exports = __webpack_public_path__ + "static/media/scratches.ea717692.jpg";